module.exports = __webpack_public_path__ + "img/knowledge.e68cac1d.png";